export const NOTIFICATION_MESSAGE_DURATION = 5
